import React from 'react';
import { useTranslation } from 'react-i18next';
import { GiForkKnifeSpoon } from 'react-icons/gi';
import { LiaStoreAltSolid } from "react-icons/lia";
import { isNotEmpty, YuklenenLogoUrl } from '../Utils';
export default function Header({ logoSrc, bannerSrc, place, hours, companyColor }) {
    const { t } = useTranslation("translation", { keyPrefix: "header" });
    return (
        <header className="custom_header">
            {
                isNotEmpty(logoSrc) && (
                    <div className="custom_header__logo-container">
                        <img className="custom_header__logo" src={YuklenenLogoUrl + logoSrc} alt="Logo" />
                    </div>
                )
            }
            <div className="custom_header__banner-image">
                <img src={bannerSrc} />
            </div>

            <div className="custom_header__info-bar" style={{ backgroundColor: companyColor }}>
                <div className="custom_header__info-container">
                    <div className="custom_header__info-left">
                        <div className="custom_header__info-row">
                            <LiaStoreAltSolid className="custom_header__icon" style={{ color: companyColor }} />
                            <span className="custom_header__info-place">{place}</span>
                        </div>
                        <div className="custom_header__info-row">
                            <GiForkKnifeSpoon className="custom_header__icon" style={{ color: companyColor }} />
                            <span className="custom_header__info-hours">
                                {t("ourWorkingHours", { hours: hours })}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}
